import Vue from 'vue'
import { IMG_URL } from '@/api/config'
import $util from '@/services/ht.util'
import { CodeToText } from 'element-china-area-data'

Vue.filter('imgUrl', function (url) {
  return IMG_URL + url
})

Vue.filter('week', function (day) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  switch (day) {
    case 1:
      return '周一'

    case 2:
      return '周二'

    case 3:
      return '周三'

    case 4:
      return '周四'

    case 5:
      return '周五'

    case 6:
      return '周六'

    case 7:
      return '周日'

    default:
      return '/'
  }
})
// 手机号码隐藏
Vue.filter('mobile', function (val) {
  val = val + ''
  return val.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
})

Vue.filter('consStatus', function (status) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  switch (status) {
    case 0:
      return '未提交'

    case 1:
      return '已提交'

    case 2:
      return '已受理'

    case 3:
      return '已拒绝'

    case 4:
      return '已完成'
  }
})

Vue.filter('content', function (content) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if (content) {
    let str = content + ''
    return str.replace(/<.*?>/gi, '').replace(/&nbsp;/g, '')
  } else {
    return ''
  }
})

Vue.filter('cost', function (data) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  switch (data) {
    case 0:
      return '成本价'

    case 1:
      return '公开价'

    case 2:
      return '会员价'
  }
})

Vue.filter('price', function (data, n) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if (data) {
    return Number(data).toFixed(n || 2)
  } else {
    return '\\'
  }
})

Vue.filter('number', function (data, n) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if (data) return Number(data).toFixed(n)
})

Vue.filter('compMemIdent', function (data) {
  switch (data) {
    case 0:
      return '物流供应商'

    case 1:
      return '货主'

    case 3:
      return '经纪人'
  }
})

Vue.filter('copmStatus', function (data) {
  switch (data) {
    case 0:
      return '未提交审核'

    case 1:
      return '企业已认证'

    case 2:
      return '待审核'
  }
})

Vue.filter('date', function (data) {
  var date = $util.formatDate(new Date(data), 'yyyy-MM-dd')
  return date
})

Vue.filter('unitCode', function (data) {
  switch (data) {
    case 0:
      return '按票'

    case 1:
      return '按箱'
  }
})

Vue.filter('partnerStatus', function (data) {
  switch (data) {
    case 0:
      return '待确认'

    case 1:
      return '互认伙伴'

    case 2:
      return '黑名单'
  }
})

Vue.filter('demandStatus', function (status) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  switch (status) {
    case 0:
      return '未发布'

    case 1:
      return '已发布'

    case 2:
      return '比价中'

    case 3:
      return '已成交'

    case 4:
      return '已失效'
  }
})

Vue.filter('offerStatus', function (status) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  switch (status) {
    case 1:
      return '已报价'

    case 2:
      return '已成交'

    case 3:
      return '已失效'
  }
})

Vue.filter('cargoDescribe', function (cargoDescribe) {
  // 全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
  if (cargoDescribe.length > 48) {
    let str = cargoDescribe.substring(0, 48)
    return str + '...'
  } else {
    return cargoDescribe
  }
})

Vue.filter('cargoTypeName', function (data) {
  switch (data) {
    case 1:
      return '普货'

    case 2:
      return '冷藏品'

    case 3:
      return '危险品'
  }
})

Vue.filter('asterisk', function (data) {
  return '***'
})

Vue.filter('chinaArea', function (data) {
  if (data) {
    return (
      CodeToText[data.split(',')[0]] +
      ' ' +
      CodeToText[data.split(',')[1]] +
      ' ' +
      CodeToText[data.split(',')[2]]
    )
  } else {
    return data
  }
})

Vue.filter('portType', (data) => {
  switch (data) {
    case 1:
      return '起运港'

    case 2:
      return '目的港'
  }
})

Vue.filter('unitCode', (data) => {
  switch (data) {
    case 'B/L':
      return '单票'

    case 'CTNS':
      return '单柜'

    case 'GOODS':
      return '单货'
  }
})
